import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const Markdown = ({ children }) => {
	const renderers = {
		code: ({ children }) => <div>{children}</div>,
		pre: ({ children }) => <div>{children}</div>,
	};
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return <ReactMarkdown components={renderers} rehypePlugins={[rehypeRaw]}>{children}</ReactMarkdown>;
};

export { Markdown };
